/**
 * Hero slider text animations – vanilla JS (no GSAP/SplitText).
 * Runs when script loads (hero-inview); splits text and adds classes for CSS animations.
 */
(function () {
  var root = document.querySelector('.header-slider');
  if (!root) return;

  var captionCol = root.querySelector('.caption_txt_col');
  if (!captionCol) return;

  /**
   * Split element text into character spans for stagger animation.
   */
  function splitChars(el) {
    var text = (el.textContent || '').trim();
    if (!text) return;
    el.textContent = '';
    var fragment = document.createDocumentFragment();
    for (var i = 0; i < text.length; i++) {
      var span = document.createElement('span');
      span.className = 'hero-char';
      span.style.setProperty('--char-i', i);
      span.textContent = text[i] === ' ' ? '\u00A0' : text[i];
      fragment.appendChild(span);
    }
    el.appendChild(fragment);
  }

  /**
   * Split element text into line wrappers (lineParent > lineChild) for line-by-line animation.
   */
  function splitLines(el) {
    var text = (el.textContent || '').trim();
    if (!text) return;
    var words = text.split(/\s+/).filter(Boolean);
    if (!words.length) return;

    var wrapper = document.createElement('span');
    wrapper.setAttribute('aria-hidden', 'true');
    wrapper.style.cssText = 'display:block; width:100%; position:relative;';

    words.forEach(function (word) {
      var span = document.createElement('span');
      span.textContent = word + ' ';
      span.style.display = 'inline';
      wrapper.appendChild(span);
    });

    el.textContent = '';
    el.appendChild(wrapper);

    var wordSpans = wrapper.querySelectorAll('span');
    var lineGroups = [];
    var currentLine = [];
    var lastTop = null;

    for (var i = 0; i < wordSpans.length; i++) {
      var rect = wordSpans[i].getBoundingClientRect();
      if (lastTop !== null && rect.top > lastTop + 2) {
        lineGroups.push(currentLine);
        currentLine = [];
      }
      currentLine.push(wordSpans[i]);
      lastTop = rect.top;
    }
    if (currentLine.length) lineGroups.push(currentLine);

    wrapper.innerHTML = '';
    lineGroups.forEach(function (lineSpans, lineIndex) {
      var lineParent = document.createElement('span');
      lineParent.className = 'lineParent';
      lineParent.style.display = 'block';
      var lineChild = document.createElement('span');
      lineChild.className = 'lineChild';
      lineChild.style.display = 'block';
      lineChild.style.setProperty('--line-i', lineIndex);
      lineSpans.forEach(function (s) {
        lineChild.appendChild(s);
      });
      lineParent.appendChild(lineChild);
      wrapper.appendChild(lineParent);
    });
  }

  var subHeading = root.querySelector('.anim-text.sub_heading_txt');
  if (subHeading) splitChars(subHeading);

  var h2 = root.querySelector('h2.anim-text');
  if (h2) splitLines(h2);

  var caption = root.querySelector('.caption_txt');
  if (caption) splitLines(caption);

  captionCol.classList.add('hero-animation-ready');
})();
